import { YnEnum, NftTitleEnum, KlipCompanyNameEnum, } from './common.enums';


export const ProductDetailResultTypeAndMessage = {
    DEFAULT: '',
    SUCCESS: '제품 코드가 올바르게 입력되었습니다.',
    NOTFOUND: '존재하지 않는 제품 코드입니다.',
    ALREADYISSUED: '이미 인증서가 발행된 제품 코드입니다.',
    DISPOSED: '폐기된 제품입니다.',
    DUPLICATED: '중복되는 제품코드가 있습니다. 다시 확인해주세요.'
}

export const CertifiedCompanies = {
    default: {
        name: '',
        engName: '',
        iconUrl: '',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
        nftTitle: NftTitleEnum.ETC,
    },
    dentium: {
        name: '덴티움',
        engName: 'dentium',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round%252FDentium.svg',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDentium.png',
        colorCode: '#EAF1C5',
        nftTitle: NftTitleEnum.DENTIUM,
        klipCompanyName: KlipCompanyNameEnum.DENTIUM,
        description: `본 카드는 (주)덴티움에서 제조한 정품 임플란트를 정식으로 공급 받아 사용하였음을 인증합니다.`,
        translatedText: {
            zh: {
                description: '本卡证明使用的是由Dentium公司正式供应的正品种植体。'
            }
        }
    },
    pointImplant: {
        name: '포인트임플란트',
        engName: 'pointImplant',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round%252FPointImplant.svg',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPointImplant.png',
        imgUrl2: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPointImplantAdditional.png',
        colorCode: '#CCD8FF',
        nftTitle: NftTitleEnum.POINTIMPLANT,
        nftTitle2: NftTitleEnum.POINTIMPLANTUV,
        klipCompanyName: KlipCompanyNameEnum.POINTIMPLANT,
        description: `본 카드는 포인트임플란트에서 제조한 정품 임플란트를 정식으로 공급 받아 사용하였음을 인증합니다.`,
        description2: `포인트임플란트는 특허받은 자외선(UV) 광활성 임플란트입니다. 세계 최초로 밀폐형 광활성 처리기술을 사용한 임플란트로 오랫동안 단단하게 임플란트를 유지할 수 있습니다.<br><br>

        ▶ 포인트 UV 임플란트 강점<br>
        약한뼈에 더 좋은 UV 임플란트<br>
        치유기간을 약 3~4주 빠르게 단축<br>
        골융합 속도(4배), 골밀도(2배) 증가<br>
        높은 수술 성공률<br>
        장기적인 안정성<br><br>

        ▶ 포인트 UV 임플란트 특장점<br>
        뛰어난 생체활성도(초 친수성)<br>
        표면노화(탄화수소) 제거<br>
        표면전하 회복<br>
        표면의 향균성 유지<br>
        골유착 속도 증대`
    },
    withwellImplant: {
        name: '위드웰임플란트',
        engName: 'withwellImplant',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round/WithWellImplant.svg',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card/WithWellImplant.png',
        colorCode: '#D3E1F6',
        nftTitle: NftTitleEnum.WITHWELLIMPLANT,
        klipCompanyName: KlipCompanyNameEnum.WITHWELLIMPLANT,
        description: `본 카드는 위드웰임플란트에서 제조한 정품 임플란트를 정식으로 공급 받아 사용하였음을 인증합니다.`,
    },
    dentis: {
        name: '덴티스',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
}

export const ChinaCertificatedCompanies = {
    default: CertifiedCompanies.default,
    dentium: CertifiedCompanies.dentium
}

export const getCertifiedCompanyByKoreanName = (name) => {
    const companyName = Object.keys(CertifiedCompanies).find(key => CertifiedCompanies[key].name === name);
    return CertifiedCompanies[companyName] || null;
}

export const SurfaceCompanies = {
    plasmapp: {
        name: '플라즈맵',
        iconUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPlasmapp.png',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPlasmapp.png',
        colorCode: '#DED9F2',
    },
}

export const NotCertifiedCompanies = {
    default: {
        name: '',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    dio: {
        name: '디오',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    megazen: {
        name: '메가젠',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    osstem: {
        name: '오스템',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    neo: {
        name: '네오',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    straumann: {
        name: '스트라우만',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    },
    etc: {
        name: '기타',
        imgUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FDefault.png',
        colorCode: '#C7CCD1',
    }
}

/* 
    치아 객체 일종의 enum
    proxy object의 동작 방식이 특이하여 객체의 depth를 최소화함
*/

export const implantTooth = {
    isCertified: null, // 인증제조사인지 아닌지, boolean
    toothNum: 0, // 치아번호

    
    resultMessage: ProductDetailResultTypeAndMessage.default,
    sentPushRequest: false,
    timer: null,
    pushId: '',
    
    // 표면처리 UI 관련
    didSurfaceProcess: false, // 표면처리 선택 여부
    isSurfaceListShowing: false, // 드롭다운 목록 노출 여부(커스텀 드롭다운)
    surfaceProcessText: '별도의 표면 처리가 적용되지 않았습니다.',  // 표면처리 문구
    // 표면처리 데이터 관련
    surfaceImageUrl: '', // 표면처리 제품 이미지 url
    surfaceItemId: '', // 표면처리 품목 ID
    surfaceItemName: '', // 표면처리 품목명
    surfaceProductCode: '', // 표면처리 제품 코드
    surfaceNftIssueCount: '', // 발행 횟수(~회 사용)
    
    // 포인트임플란트 UV
    didUV: false,
    uvProcessText: 'UV 처리가 적용되지 않았습니다.',



    // 공통정보
    group: CertifiedCompanies.dentium.name, // 회사명(아마 비즈메시지용 변수)
    itemName: '', // 품목명
    metadataInfo: { // 클립용 메타데이터
        attributes: [], // 클립 설명란 하단에 들어가는 항목들
        background_color: CertifiedCompanies.dentium.colorCode, // 클립앱 NFT목록에서 나오는 배경색
        description: '', // 제목 아래 나오는 설명
        group_name: CertifiedCompanies.dentium.name, // 회사명(클립용 변수)
        image: CertifiedCompanies.dentium.imgUrl, // 이미지 url
        name: '', // 클립에서 보여줄 NFT 제목
    },

    // 인증제조사 중 제품코드로 입력할 때 받는 정보 
    itemCode: '', // 품목 코드
    productCode: '', // 제품 코드
    productId: '', // 제품 ID
    productType: '', // 제품 타입(치아 임플란트 등)

    duplicateYn: YnEnum.Y, // 중복 허용 여부

    // 치아제품목록에서 선택
    selectedDentItemStepOne: '', // 제조사
    selectedDentItemStepTwo: '', // 브랜드
    selectedDentItemStepThree: '', // 사양
    
    // 인증제조사인데 커스텀값, 제조사는 현재 하나여서 없음
    selectedCustomCertifiedDentItemStepTwo: '', // 브랜드
    selectedCustomCertifiedDentItemStepThree: '', // 사양
    
    // 인증제조사가 아닌데 커스텀값
    selectedCustomDentItemStepOne: '',  // 제조사
    selectedCustomDentItemStepTwo: '',  // 브랜드
    selectedCustomDentItemStepThree: '',  // 사양

    dentItemStepOne: { // 
        dentium: [],
        pointImplant: [],
        other: [],
    },
    dentItemStepTwo: {
        title: '제품명',
        list: [],
    },
    dentItemStepThree: {
        title: '제품 사양',
        list: [],
    },
    dentItemStepOneList: [],

    // 클릭클릭 관련
    willTypeProductCode: false, // 제품코드 직접 입력 여부
    willTypeCertifiedProductInfoTwo: false, // 인증제조사 브랜드 직접입력 여부
    willTypeCertifiedProductInfoThree: false, // 인증제조사 사양 직접입력 여부
    willTypeNotCertifiedProductInfoOne: false, // 미인증제조사명 직접입력 여부
    willTypeNotCertifiedProductInfoTwo: false, // 미인증제조사 브랜드 직접입력 여부
    willTypeNotCertifiedProductInfoThree: false, // 미인증제조사 사양 직접입력 여부
}

export function createImplantTooth() {
    return implantTooth;
}

export const DentItemCompanies = { // 치아 제조사 호출용 enum
    DENTIUM: '덴티움',
    POINTIMPLANT: '포인트임플란트',
    WITHWELLIMPLANT: '위드웰임플란트',
    OTHER: 'other',
}